//全局变量

export default {
    //token无效标记
    TokenInvalidCounter :0
}